import type { AxiosApiResponsePromise } from "~/api/apiResponseTypes.ts";
import axiosApi from "~/api/axiosApi";
import type { TimeTrackingType } from "~/modules/timeTracking/api/timeTrackingType/timeTrackingTypeTypes.ts";


export const getAllTimeTrackingTypes = (): AxiosApiResponsePromise<TimeTrackingType[]> => axiosApi.get("time-tracking-types");
